import { TransactionMapper } from './TransactionMapper.js';

class InvoicingRepository {
  constructor(apiClient) {
    this.apiClient = apiClient;
  }
  getTransactions() {
    let params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const queryParams = {
      order_reference: params.orderReference,
      from: params.from,
      to: params.to,
      page: params.page,
      size: params.size
    };
    return this.apiClient.get('v1/invoicing/transactions', queryParams).then(response => TransactionMapper.createTransactionsFromResponse(response.data));
  }
}

export { InvoicingRepository };
//# sourceMappingURL=InvoicingRepository.js.map
